import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { apiFetch } from "api/Api";
import { FaArrowLeft } from "react-icons/fa";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import "assets/theme/admin_form.css";

const EditCategoryField = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [fieldLabel, setFieldLabel] = useState("");
  const [fieldKey, setFieldKey] = useState("");
  const [fieldType, setFieldType] = useState("text");
  const [isRequired, setIsRequired] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadCategories();
    loadFieldData();
  }, []);

  const loadCategories = async () => {
    try {
      const data = await apiFetch("super_admin/list_help_category");
      setCategories(data.categories);
    } catch (error) {
      alert(error.message);
    }
  };

  const loadFieldData = async () => {
    try {
      const data = await apiFetch(`super_admin/get_category_wise_field_by_id/${id}`);
      const field = data.category_field;
      setCategoryId(field.category_id);
      setFieldLabel(field.field_label);
      setFieldKey(field.field_key);
      setFieldType(field.field_type);
      setIsRequired(field.is_required);
    } catch (error) {
      alert(error.message);
    }
  };

  const generateKey = (label) => {
    return label
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace(/[^a-z0-9_]/g, "");
  };

  const handleLabelChange = (e) => {
    const value = e.target.value;
    setFieldLabel(value);
    setFieldKey(generateKey(value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!categoryId || !fieldLabel.trim()) {
      return alert("All fields are required");
    }

    setLoading(true);

    try {
      await apiFetch(`super_admin/edit_category_wise_field/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          category_id: categoryId,
          field_label: fieldLabel.trim(),
          field_key: fieldKey.trim(),
          field_type: fieldType,
          is_required: isRequired,
        }),
      });

      alert("Field updated successfully");
      navigate("/category_field_list");
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>
        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                ✏️ श्रेणी फील्ड संपादित करा (Edit Category Field)
              </h4>
              <small className="text-white-50">
                Update dynamic help-form field details
              </small>
            </div>
          </div>

          <Link to="/category_field_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Fields List
          </Link>
        </div>

        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">
            <form onSubmit={handleSubmit}>
              <div className="row g-4">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Select Category</label>
                  <select
                    className="form-select"
                    value={categoryId}
                    onChange={(e) => setCategoryId(e.target.value)}
                    required
                  >
                    <option value="">Select Category</option>
                    {categories.map((cat) => (
                      <option key={cat.category_id} value={cat.category_id}>
                        {cat.category_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Field Label</label>
                  <input
                    type="text"
                    className="form-control"
                    value={fieldLabel}
                    onChange={handleLabelChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Field Key</label>
                  <input type="text" className="form-control" value={fieldKey} readOnly />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Field Type</label>
                  <select
                    className="form-select"
                    value={fieldType}
                    onChange={(e) => setFieldType(e.target.value)}
                  >
                    <option value="text">Text</option>
                    <option value="number">Number</option>
                    <option value="date">Date</option>
                    <option value="textarea">Textarea</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Required Field</label>
                  <div className="form-check form-switch mt-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={isRequired}
                      onChange={(e) => setIsRequired(e.target.checked)}
                    />
                    <label className="form-check-label">Mark as required</label>
                  </div>
                </div>
              </div>

              <div className="mt-4 text-end">
                <button type="submit" className="btn btn-primary px-5" disabled={loading} style={{ fontSize: "0.85rem" }}>
                  {loading ? "Updating..." : "Update Field"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default EditCategoryField;
